import React, { useEffect, useState, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../../../utils/useNavigation";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PendingDeleteIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import HoverCard from "../../../../hoverCard/HoverCard";
import { utcToLocalDateString, dateOnlyFormatted } from "../../../../../utils/systemSettings";
import CustomInput from "../../../input/customInput/CustomInput";
import userService from "../../../../../store/services/user.service";
import industryService from "../../../../../store/services/industry.service";
import CustomSelect from "../../../select/CustomSelect";
import {
  createClientRequest,
  updateClientRequest,
} from "../../../../../store/actions/clients.actions";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../../../store/actions";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const ClientRow = (props) => {
  const {
    sortingCriteria,
    data,
    handleModal,
    menu,
    sortClientRequest,
    updateFlag,
    columnConfig,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const [setting] = useState(settings);
  const [resources, setResources] = useState([]);
  const [ownerId, setOwnerId] = useState("");
  const [industryOptions, setIndustryOptions] = useState([]);
  const clientNameInputRef = useRef(null);
  // const companyNameInputRef = useRef(null);
  const clientManagerInputRef = useRef(null);
  const industryInputRef = useRef(null);
  const statusInputRef = useRef(null);
  const contractStartDateInputRef = useRef(null);
  const contractEndDateInputRef = useRef(null);
  const popoverRef = useRef(null);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    completion: "",
    projectId: "",
  });

  const [isEditRecord, setIsEditRecord] = useState(null);

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      sortClientRequest({
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      });
    }
  }, [sortingCriteria]);

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data?.owner) {
      data.ownerId = data.owner.id;
    }
    if (data?.industries) {
      data.industryIds = data.industries.map((i) => i.id);
    }
    if (data.name) {
      if (data.id) {
        dispatch(
          updateClientRequest({
            id: sortedData[isEditRecord.index].id,
            type: "listing",
            payload: data,
          })
        );
      } else {
        let finalPayload = new FormData();
        for (const key in data) {
          if (data[key] !== undefined && data[key] !== null) {
            finalPayload.append(key, data[key]);
          }
        }
        dispatch(createClientRequest({ finalPayload }));
      }
      setIsEditRecord(null);
    } else {
      let errors = {};
      if (!data.user) {
        errors["name"] = "Name is a required Field";
        setFormErrors(errors);
        return dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      }
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      let tempData = [...data];
      tempData.push({
        name: null,
        owner: null,
        companyName: null,
        industries: [],
        status: null,
        contractStartDate: null,
        contractEndDate: null,
      });
      setSortedData(tempData);
    }
  }, [data]);

  const handleRedirect = (item) => {
    // Use navigation hook instead of localStorage
    navigateTo("Clients", item.id, item.name);
  };

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);
  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    let tempData = [...sortedArray];
    tempData.push({
      name: null,
      owner: null,
      companyName: null,
      industries: [],
      status: null,
      contractStartDate: null,
      contractEndDate: null,
    });
    setSortedData(tempData);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      setFormErrors({ ...formErrors, name: "" });
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "company") {
      data.name.companyName = value;
      setIsEditRecord(data);
    } else if (type === "manager") {
      if (value) {
        if (!data?.name?.owner) {
          data.name.owner = {};
        }
        data.name.owner.name = value.label;
        data.name.owner.id = value.value;
      } else {
        data.name.owner = null;
      }

      setIsEditRecord(data);
    } else if (type === "industry") {
      data.name.industries = value;
      setIsEditRecord(data);
    } else if (type === "status") {
      data.name.status = value;
      setIsEditRecord(data);
    } else if (type === "contractStart") {
      data.name.contractStartDate = value;
      setIsEditRecord(data);
    } else if (type === "contractEnd") {
      data.name.contractEndDate = value;
      setIsEditRecord(data);
    }
  };

  const searchHandler = (value) => {
    if (value === "") {
      setResources([]);
      return;
    }
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };

  const industrySearchHandler = (value) => {
    industryService
      .searchIndustriesRequest(value)
      .then((res) => {
        const transformedArray = (res || []).map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setIndustryOptions(transformedArray);
      })
      .catch(() => {
        setIndustryOptions([]);
      });
  };

  const handleIndustriesChange = (ids) => {
    const pool = [
      ...(isEditRecord?.name?.industries || []),
      ...industryOptions.map((o) => ({ id: o.value, name: o.label })),
    ];
    const selected = ids
      .map((id) => pool.find((item) => item.id === id))
      .filter(Boolean);
    handleInputChange(selected, "industry");
  };

  const handleIndustryCreated = (created) => {
    const next = [
      ...(isEditRecord?.name?.industries || []),
      { id: created.value, name: created.label },
    ];
    handleInputChange(next, "industry");
  };

  const handleIsEdiRecord = (index, type) => {
    if (index === data.length && type !== "name") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    if (isEditRecord && isEditRecord.index === index) {
      focusField(type);
      return;
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const focusField = (type) => {
    switch (type) {
      case "name":
        clientNameInputRef.current?.focus();
        break;
      // case "company":
      //   companyNameInputRef.current?.focus();
      //   break;
      case "manager":
        clientManagerInputRef.current?.focus();
        break;
      case "industry":
        industryInputRef.current?.focus();
        break;
      case "contractEnd":
        contractEndDateInputRef.current?.focus();
        break;
      case "contractStart":
        contractStartDateInputRef.current?.focus();
        break;
      case "status":
        statusInputRef.current?.focus();
        break;
      default:
        break;
    }
  };
  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////
  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Client":
        return (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <div className="d-flex justify-content-between align-items-center inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder="Enter name"
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={clientNameInputRef}
                    errorMessage={formErrors.name}
                    displayErrorMessage={false}
                  />
                ) : item?.id ? (
                  <span
                    className="d-flex w-full text-truncate"
                    onClick={() => handleRedirect(item)}
                  >
                    {item.isPendingDelete && <div className="mr-1"><PendingDeleteIcon/></div>}
                    {item.name}
                  </span>
                ) : (
                  <div
                    className="d-flex _add_btn"
                    onClick={() =>
                      handleIsEdiRecord(sortedData.length - 1, "name")
                    }
                  >
                    <PlusIcon />
                    Add
                  </div>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      // case "Company":
      //   return (
      //     <TableCell onClick={() => handleIsEdiRecord(index, "company")}>
      //       {isEditing ? (
      //         <CustomInput
      //           inputwd="inputWidth me-3"
      //           icon={false}
      //           placeholder="Enter company name"
      //           value={isEditRecord.name.companyName}
      //           type="text"
      //           handleChange={(value) => handleInputChange(value, "company")}
      //           ref={companyNameInputRef}
      //         />
      //       ) : (
      //         item.companyName
      //       )}
      //     </TableCell>
      //   );
      case "Client Manager":
        return (
          <TableCell
            role="gridcell"
            onClick={() => handleIsEdiRecord(index, "manager")}
          >
            {isEditing ? (
              <CustomSelect
                SelectText="manager"
                searchText={searchHandler}
                options={resources}
                onClick={() => clientManagerInputRef.current?.focus()}
                defaultVal={
                  isEditRecord.name.manager?.name
                    ? {
                        label: isEditRecord.name.manager.name,
                        value: isEditRecord.name.manager.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "manager")}
                creatable={true}
                setCreated={setOwnerId}
                CustomClass="ModalAvatarSearch"
                handleInputChange={handleInputChange}
              />
            ) : item.manager ? (
              <TableCellLayout
                media={
                  <HoverCard
                    HoverCardTrigger={
                      <Avatar
                        color="colorful"
                        name={item.manager?.name || item.manager?.email || item.manager?.phone}
                        image={{ src: "" }}
                      />
                    }
                    AvatarName={item.manager?.name || item.manager?.email || item.manager?.phone}
                    AvatarDesignation="Manager"
                    AvatarEmail={item.manager?.email}
                    AvatarPhone={item.manager?.phone}
                    AvatarIsExternal={true}
                    CanSendMessage={false}
                  />
                }
              >
                {item.manager?.name || item.manager?.email || item.manager?.phone}
              </TableCellLayout>
            ) : (
              <TableCell>{item.manager?.name || item.manager?.email || item.manager?.phone}</TableCell>
            )}
          </TableCell>
        );
      case "Industry":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "industry")}>
            {isEditing ? (
              <CustomSelect
                SelectText="industry"
                multiselect={true}
                creatable={true}
                searchText={industrySearchHandler}
                options={industryOptions}
                defaultVal={(isEditRecord.name.industries || []).map((i) => ({
                  label: i.name,
                  value: i.id,
                }))}
                onChange={handleIndustriesChange}
                createOptionRequest={(name) => industryService.createIndustryRequest(name)}
                setCreated={handleIndustryCreated}
                CustomClass="ModalAvatarSearch"
              />
            ) : (
              (item.industries || []).map((i) => i.name).join(", ")
            )}
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "status")}>
            {isEditing ? (
              <CustomInput
                icon={false}
                placeholder="Enter status"
                value={isEditRecord.name.status}
                type="text"
                handleChange={(value) => handleInputChange(value, "status")}
                ref={statusInputRef}
              />
            ) : (
              item.status
            )}
          </TableCell>
        );
      case "Contract Start Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "contractStart")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.contractStartDate}
                type="date"
                handleChange={(value) =>
                  handleInputChange(value, "contractStart")
                }
                ref={contractStartDateInputRef}
              />
            ) : item.contractStartDate ? (
              dateOnlyFormatted(setting, item.contractStartDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Contract End Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "contractEnd")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.contractEndDate}
                type="date"
                handleChange={(value) =>
                  handleInputChange(value, "contractEnd")
                }
                ref={contractEndDateInputRef}
              />
            ) : item.contractEndDate ? (
              dateOnlyFormatted(setting, item.contractEndDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Creation Date":
        return (
          <TableCell>
            {item.dateCreated
              ? utcToLocalDateString(setting, item.dateCreated)
              : ""}
          </TableCell>
        );
      default:
        return null;
    }
  };

  const styles = useStyles();
  return sortedData.map((item, index) => (
    <TableRow key={item.id || index} className="ProjectHover" ref={popoverRef}>
      {sortedColumnConfig
        .filter((col) => col.isVisible)
        .map((col) => renderTableCell(item, index, col))}
    </TableRow>
  ));
};

export default ClientRow;
